import { addPence, pence, ZERO_PENCE } from '@cf/shared';
import { assertReviewed } from './review.js';
import { excessOver, minPence, mulBps } from './bps.js';
export function nationalInsurance(rules, input) {
    assertReviewed(rules);
    const r = rules.nationalInsurance;
    const earnings = input.employmentEarnings ?? ZERO_PENCE;
    const profits = input.selfEmploymentProfits ?? ZERO_PENCE;
    for (const [label, v] of Object.entries({ earnings, profits })) {
        if (!Number.isSafeInteger(v) || v < 0) {
            throw new RangeError(`nationalInsurance ${label} must be a non-negative integer of pence`);
        }
    }
    const class1Main = minPence(excessOver(earnings, r.class1PrimaryThreshold), excessOver(r.class1UpperEarningsLimit, r.class1PrimaryThreshold));
    const class1Upper = excessOver(earnings, r.class1UpperEarningsLimit);
    const class1 = addPence(mulBps(class1Main, r.class1MainRateBps), mulBps(class1Upper, r.class1UpperRateBps));
    const class4Main = minPence(excessOver(profits, r.class4LowerProfitsLimit), excessOver(r.class4UpperProfitsLimit, r.class4LowerProfitsLimit));
    const class4Upper = excessOver(profits, r.class4UpperProfitsLimit);
    const class4 = addPence(mulBps(class4Main, r.class4MainRateBps), mulBps(class4Upper, r.class4UpperRateBps));
    return { class1: pence(class1), class4: pence(class4), total: addPence(class1, class4) };
}
//# sourceMappingURL=national-insurance.js.map